import React, { useEffect, useState, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { Alert, Form } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import {
  Icon,
  Button,
  TooltipComponent,
} from "../../../components/Component";
import { Row, Col } from "reactstrap";
import contractorsApis from "../../../api/master/contractors";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
const EmergencyResponseandContingencyPlans: React.FC = (props: any) => {
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const navigate = useNavigate();
  const [alertInfo, setAlertInfo] = useState<{
    type: string;
    message: string;
    errors: string[];
  }>({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });
  const submitForm = (data: any) => {
    console.log("Final form data:", data);
    createClient(data);
    // Add your API submission logic here
  };
  const emergencyProceduresWatch = watch("emergencyProcedures");

  useEffect(() => {
    const fileSizeCheck = (files: any) => {
      if (files && files[0]?.size && files[0].size > 2097152) {
        Swal.fire({
          icon: "error",
          title: "File size should be less than 2MB.",
        });
      }
    };

    fileSizeCheck(emergencyProceduresWatch);
  }, [emergencyProceduresWatch]);

  const createClient = async (data: any) => {
    const allFormData = getValues();
    const cleanedFormData = Object.fromEntries(
      Object.entries(allFormData).filter(([_, value]) => {
        return value !== "" && value !== null && value !== undefined;
      })
    );

    const {
      regulatoryCompliancedocsUpload,
      licensesAndPermitsdocsUpload,
      insuranceCoveragedocsUpload,
      ScopeofWorkdocsUpload,
      BillingandPaymentTermsdocsUpload,
      contractTermsdocsUpload,
      environmentalCompliancedocsUpload,
      wasteManagementProceduresdocsUpload,
      qualityAssurancePlandocsUpload,
      disputeResolutionProcessdocsUpload,
      emergencyProcedures,
      businessType,
      ...clientData
    } = cleanedFormData;
    // Create a clean payload based on business type
    const cleanPayload = { ...clientData };

    if (businessType === "unregistered") {
      delete cleanPayload.gstin;
      delete cleanPayload.incorporationDate;
      delete cleanPayload.lastFYTurnover;
      delete cleanPayload.lastFyTurnover;
    } else if (businessType === "registered") {
      delete cleanPayload.cin;
    }

    const filesData = [];
    const files = [];
    const formData: any = new FormData();
    if (regulatoryCompliancedocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "regulatoryCompliancedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(regulatoryCompliancedocsUpload[0]);
    }
    if (licensesAndPermitsdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "licensesAndPermitsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(licensesAndPermitsdocsUpload[0]);
    }
    if (insuranceCoveragedocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "insuranceCoveragedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(insuranceCoveragedocsUpload[0]);
    }
    if (ScopeofWorkdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "ScopeofWorkdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(ScopeofWorkdocsUpload[0]);
    }
    if (BillingandPaymentTermsdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "BillingandPaymentTermsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(BillingandPaymentTermsdocsUpload[0]);
    }
    if (contractTermsdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "contractTermsdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(contractTermsdocsUpload[0]);
    }
    if (environmentalCompliancedocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "environmentalCompliancedocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(environmentalCompliancedocsUpload[0]);
    }
    if (wasteManagementProceduresdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "wasteManagementProceduresdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(wasteManagementProceduresdocsUpload[0]);
    }
    if (qualityAssurancePlandocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "qualityAssurancePlandocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(qualityAssurancePlandocsUpload[0]);
    }
    if (disputeResolutionProcessdocsUpload[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "disputeResolutionProcessdocsUpload",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(disputeResolutionProcessdocsUpload[0]);
    }
    if (emergencyProcedures[0]) {
      filesData.push({
        indexOfFileLocated: filesData.length,
        module: "client",
        purpose: "emergencyProcedures",
        level: "Header Level",
        uniqueId: "",
        action: "Create",
      });
      files.push(emergencyProcedures[0]);
    }

    delete data.regulatoryCompliancedocsUpload;
    delete data.licensesAndPermitsdocsUpload;
    delete data.insuranceCoveragedocsUpload;
    delete data.ScopeofWorkdocsUpload;
    delete data.BillingandPaymentTermsdocsUpload;
    delete data.contractTermsdocsUpload;
    delete data.environmentalCompliancedocsUpload;
    delete data.wasteManagementProceduresdocsUpload;
    delete data.qualityAssurancePlandocsUpload;
    delete data.disputeResolutionProcessdocsUpload;
    delete data.emergencyProcedures;
    formData.append(
      "contractorData",
      JSON.stringify({ ...cleanPayload, businessType, partyType: "Client" })
    );
    formData.append("filesData", JSON.stringify(filesData));
    files.forEach((file) => {
      formData.append(`files`, file);
    });
    const response = await contractorsApis.createContractor(formData);
    const { status, message } = response;
    if (status) {
      Swal.fire("Created!", "Client has been created", "success");
      navigate(`/clients`);
    } else {
      console.log("Error in form submission", message, response);
      let errorMessage = "An error occurred";
      let errorList: string[] = [];

      if (typeof message === "string") {
        errorList.push(message);
      } else if (Array.isArray(message)) {
        message.forEach((errObj: any) => {
          if (errObj.field && Array.isArray(errObj.errors)) {
            errObj.errors.forEach((errMsg: string) => {
              errorList.push(`${errObj.field}: ${errMsg}`);
            });
          } else if (typeof errObj === "string") {
            errorList.push(errObj);
          }
        });
      } else if (message && typeof message === "object") {
        if (message.field && Array.isArray(message.errors)) {
          message.errors.forEach((errMsg: string) => {
            errorList.push(`${message.field}: ${errMsg}`);
          });
        }
      }
      setAlertInfo({
        type: "error",
        message: errorMessage,
        errors: errorList,
      });
    }
  };

  useEffect(() => {
    setAlertInfo({
      type: "", // 'success' or 'error'
      message: "",
      errors: [],
    });
  }, []);
  return (
    <>
      {alertInfo.message && (
        <div className="mb-3 mt-1">
          <Alert
            color={alertInfo.type === "error" ? "danger" : "success"}
            className="alert-icon"
          >
            <strong>{alertInfo.message}</strong>
            <Icon
              name={
                alertInfo.type === "error" ? "alert-circle" : "check-circle"
              }
            />
            {alertInfo.errors.length > 0 ? (
              <ul>
                {alertInfo.errors.map((err: any, index: any) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </Alert>
        </div>
      )}
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col md="6">
            <FormInput
              name="emergencyContactPerson"
              label="Contact Person"
              type="text"
              placeholder="Enter Contact Person"
            />
          </Col>
          <Col md="6">
            <FormInput
              name="emergencyContactNumber"
              label="Contact Number"
              type="number"
              placeholder="Enter Contact Information"
            />
          </Col>
          <Col lg="6">
            {emergencyProceduresWatch && emergencyProceduresWatch[0]?.name && (
              <div className="form-group">
                <div className="form-label-wrapper">
                  <label className="form-label" htmlFor={"emergencyProcedures"}>
                    Upload Emergency Procedures
                  </label>
                  <TooltipComponent
                    iconClass="card-hint"
                    icon="help-fill"
                    direction="left"
                    id={`emergencyProcedures-tooltip`}
                    text="Only PNG, JPG and JPEG files are allowed"
                    containerClassName={""}
                  />
                </div>
                <div
                  className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                  style={{ borderRadius: "3px" }}
                >
                  <span>{emergencyProceduresWatch[0]?.name}</span>
                  <span
                    onClick={() => {
                      setValue("emergencyProcedures", null);
                    }}
                    style={{
                      cursor: "pointer",
                      marginLeft: "10px",
                      display: "block",
                      fontSize: 14,
                    }}
                  >
                    <Icon name="cross"></Icon> &nbsp;
                  </span>
                </div>
              </div>
            )}
            <div
              style={{
                display: `${
                  emergencyProceduresWatch && emergencyProceduresWatch[0]?.name
                    ? "none"
                    : "block"
                }`,
              }}
            >
              <FormInput
                name="emergencyProcedures"
                label="Upload Emergency Procedures"
                type="file"
                placeholder="Docs Upload"
              />
            </div>
          </Col>
        </Row>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit">
                Submit Form
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={props.prev}
                className="btn-dim btn btn-secondary"
              >
                Previous
              </Button>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
};

export default React.memo(EmergencyResponseandContingencyPlans);
